import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';
import Organization from '@/types/organizationType';

const endPoint = 'billing/cancelSubscription';
const url = apiUrl + endPoint;

const cancelSubscription = async (
  org: Organization,
  headerObj: headerObject
) => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrganizationUUID: org.OrgUUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    return JSON.parse(text);
  } catch (err) {
    console.error(err);
  }
};

export default cancelSubscription;
